import DumbMarkdown from 'markdown-to-jsx'

import { Link } from '@tribeplatform/react-ui-kit/Link'

import { BC } from '../../types/index.js'
import { MarkdownProps } from './types.js'

export const MarkdownBlock: BC<MarkdownProps> = ({ text, ...rest }) => {
  return (
    <article {...rest}>
      <DumbMarkdown
        options={{
          overrides: {
            a: {
              component: Link,
              props: {
                external: true,
              },
            },
            li: {
              component: 'li',
              props: {
                className: 'list-disc list-outside ps-6',
              },
            },
          },
        }}
      >
        {text}
      </DumbMarkdown>
    </article>
  )
}
